let componentList = []
import polyfill from './utils/manual-polyfill'
polyfill()

import Treemap from './components/TreemapComponent'
export { Treemap }
componentList.push(Treemap)

import VoronoiTreemap from './components/VoronoiTreemapComponent'
export { VoronoiTreemap }
componentList.push(VoronoiTreemap)

import BarChart from './components/BarChartComponent'
export { BarChart }
componentList.push(BarChart)

import LineChart from './components/LineChartComponent'
export { LineChart }
componentList.push(LineChart)

import StackedArea from './components/StackedAreaComponent'
export { StackedArea }
componentList.push(StackedArea)

import StackedBars from './components/StackedBarsComponent'
export { StackedBars }
componentList.push(StackedBars)

import GroupedBars from './components/GroupedBarsComponent'
export { GroupedBars }
componentList.push(GroupedBars)

import PieChart from './components/PieChartComponent'
export { PieChart }
componentList.push(PieChart)

import LineAndBarChart from './components/LineAndBarChartComponent'
export { LineAndBarChart }
componentList.push(LineAndBarChart)

import SimpleLineAndBarChart from './components/SimpleLineAndBarChartComponent'
export { SimpleLineAndBarChart }
componentList.push(SimpleLineAndBarChart)

import ParallelCoords from './components/ParallelCoordsComponent'
export { ParallelCoords }
componentList.push(ParallelCoords)

import RadarChart from './components/RadarChartComponent'
export { RadarChart }
componentList.push(RadarChart)

import DonutChart from './components/DonutChartComponent'
export { DonutChart }
componentList.push(DonutChart)

import DonutProgressChart from './components/DonutProgressChartComponent'
export { DonutProgressChart }
componentList.push(DonutProgressChart)

import ProgressBarChart from './components/ProgressBarChartComponent'
export { ProgressBarChart }
componentList.push(ProgressBarChart)

import ScatterPlot from './components/ScatterPlotComponent'
export { ScatterPlot }
componentList.push(ScatterPlot)

import BubbleChart from './components/BubbleChartComponent'
export { BubbleChart }
componentList.push(BubbleChart)

import HeatMap from './components/HeatMapComponent'
export { HeatMap }
componentList.push(HeatMap)

import CandleStick from './components/CandleStickComponent'
export { CandleStick }
componentList.push(CandleStick)

import ChoroplethSeq from './components/ChoroplethSeqComponent'
export { ChoroplethSeq }
componentList.push(ChoroplethSeq)

import ChoroplethCat from './components/ChoroplethCatComponent'
export { ChoroplethCat }
componentList.push(ChoroplethCat)

import PercentageBar from './components/PercentageBarComponent'
export { PercentageBar }
componentList.push(PercentageBar)

import SegmentedBarChart from './components/SegmentedBarChartComponent'
export { SegmentedBarChart }
componentList.push(SegmentedBarChart)

import ConnectedDotPlot from './components/ConnectedDotPlotComponent'
export { ConnectedDotPlot }
componentList.push(ConnectedDotPlot)

import WaterfallChart from './components/WaterfallChartComponent'
export { WaterfallChart }
componentList.push(WaterfallChart)

import PyramidChart from './components/PyramidChartComponent'
export { PyramidChart }
componentList.push(PyramidChart)

import { LOGOS } from './utils/logoUtils'
export * as configUtils from './utils/configUtils'
export * as dataUtils from './utils/dataUtils'
export * as colorUtils from './utils/colorUtils'
export { default as drawGradientRect } from './utils/drawGradientRect'
export { ANNOTATION_TYPES, ANNOTATION_MODES } from './viz_behaviors/AnnotationBehavior'
export const CHARTS = componentList
export const SANTANDER_LOGOS = LOGOS

export { version } from '../package.json'
